import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { IconButton, Tooltip } from '@zurich/ui/legacy/components';
import { styled } from '@zurich/ui/legacy/utils';
export const Indicator = ({ 
//children,
iconVariant, 
//primaryButtonLabel = 'Ok',
indicatorTitle, 
//isWarning = false,
onClick, }) => {
    const [, setOpen] = useState(false);
    const handleIndicator = () => {
        // open indicator modal
        setOpen(true);
    };
    return (_jsx(_Fragment, { children: _jsx(Tooltip, { description: indicatorTitle, children: _jsx(IconButtonStyled, { onClick: onClick ? onClick : handleIndicator, size: "small", variant: iconVariant }) }) }));
};
const IconButtonStyled = styled(IconButton)(({ theme, isWarning }) => ({
    fontSize: '1.2rem',
    backgroundColor: !isWarning
        ? theme.palette.primary.main
        : theme.palette.warning.main,
    color: theme.palette.primary.contrastText,
    margin: theme.spacing(1),
    '&:hover': {
        backgroundColor: !isWarning
            ? theme.palette.primary.dark
            : theme.palette.warning.dark,
    },
}));
export default Indicator;
